export const CometABI = [
    'event Supply(address indexed from, address indexed dst, uint256 amount)',
    'function supply(address asset, uint amount)',
    'function withdraw(address asset, uint amount)',
    'function balanceOf(address account) returns (uint256)',
    'function getSupplyRate(uint) public view returns (uint)',
    'function getUtilization() public view returns (uint)',
  ];